import { useMemo } from 'react';

/**
 * Reads the OAuth nonce (?k=) from the current URL once on mount and exposes
 * helpers for completing the flow.
 *
 * Spec: https://cyberint.atlassian.net/wiki/spaces/~dean/pages/1840185360/RFC+Argos+OAuth+2.1+Authorization+Server+Design (§8.1, §8.2, §16.6).
 *
 * @returns {{
 *   k: string|null,
 *   isOAuthFlow: boolean,
 *   completeFlowUrl: () => string|null
 * }}
 */
export const useOAuthFlow = () => {
  return useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    const k = params.get('k');
    return {
      k,
      isOAuthFlow: Boolean(k),
      completeFlowUrl: () => (k ? `/oauth/authorize/sso-resume?k=${encodeURIComponent(k)}` : null)
    };
  }, []);
};
